import { Outlet } from "react-router-dom";
import TopNav from "@/components/TopNav";

export default function AdminLayout() {
    return (
        <div className="min-h-screen grid-backdrop">
            <div className="max-w-6xl mx-auto px-6 py-8">
                <TopNav />
                <Outlet />
                <footer
                    className="mt-10 mono text-[10px] uppercase tracking-[0.25em] text-center"
                    style={{ color: "var(--text-faint)" }}
                >
                    phase 1 · auth + channels + rules · poc
                </footer>
            </div>
        </div>
    );
}
